<template>
  <div class="main">
    <div class="top-section">
      <div class="row m-2">
        <div class="row-items">
          <div class="search-div">
            <label for="">Total users:</label>
            <input
              type="text"
              class="form-control"
              id="count-field"
              v-model="userCount"
              readonly
            />
          </div>
          <div class="search-div">
            <label for="search-input">
              <i class="ti-search"></i>
              Search:
            </label>
            <input
              type="text"
              class="form-control"
              id="search-input"
              placeholder="Search role"
              v-model="searchQuery"
            />
          </div>
          <div style="padding-top: 30px">
            <button class="btn btn-info" @click="refresh('refresh')">
              Refresh
            </button>
          </div>
        </div>

        <div class="spinner-grow" role="status" v-if="loading === true"></div>
        <div class="alert alert-danger" role="alert" v-if="error === true">
          {{ errorMsg }}
        </div>
      </div>
      <!-- add new role -->
      <div style="margin-left: 10px">
        <router-link
          icon="ti-plus"
          class="btn btn-info m-2"
          :to="`/dashboard/add-role`"
        >
          <i class="ti-plus"></i> New Role
        </router-link>
      </div>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr style="font-size: 13px">
                <th scope="col" class="text-center">Role Name</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="role in filteredRoles"
                :key="role._id"
                style="
                  font-size: 13px;
                  background-color: #fff;
                  border-bottom: 1px solid #000;
                "
              >
                <td class="text-center">
                  <p style="color: #64acc2">{{ role.role.toUpperCase() }}</p>
                </td>
                <td class="text-center">
                  <router-link
                    :to="`/dashboard/view-role/${role._id}`"
                    class="btn btn-info m-2"
                  >
                    <i class="ti-view-list"></i>View
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";

export default {
  data() {
    return {
      error: false,
      errorMsg: "",
      loading: false,
      roles: [],
      searchQuery: "",
      userCount: 0,
    };
  },
  computed: {
    filteredRoles() {
      const filtered = this.roles.filter((role) =>
        role.role.toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
      return filtered.length ? filtered : [{ role: "No record found" }];
    },
  },
  methods: {
    async refresh() {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Roles";
      }
      this.loading = false;
    },
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/role`)
      .then((res) => {
        this.roles = res.data.roles;
        this.userCount = this.roles.length;
      })
      .catch((err) => {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Roles";
      });
  },
};
</script>

<style>
.form-row {
  padding-top: 20px;
}
.row-items {
  display: flex;
  gap: 40px;
  padding-bottom: 30px;
}
.user-count {
  text-align: center;
  background-color: #fff;
  padding: 9px;
  border-radius: 3px;
}
i {
  padding-right: 6px;
}
.search-div {
  font-size: larger;
}
#count-field {
  background-color: #fff;
  color: rgb(52, 52, 52);
  text-align: center;
  width: 80px;
  font-size: 16px;
}
</style>
